import { handleActions } from "redux-actions";

import { cleanupFilterData, getFiltersOptions, getFiltersOptionsError, getFiltersOptionsSuccess } from "./actions";

const initialState = {};

export const selectEntityByTypeReducer = handleActions(
    {
        [getFiltersOptions]: (state, { payload: { filterType } }) => ({
            ...state,
            [filterType]: { isLoading: true }
        }),
        [getFiltersOptionsSuccess]: (state, { payload: { options, filterType, ...restProps } }) => ({
            ...state,
            [filterType]: {
                options,
                isLoading: false,
                ...restProps
            }
        }),
        [getFiltersOptionsError]: (state, { payload: { filterType } }) => ({
            ...state,
            [filterType]: { isLoading: false }
        }),
        [cleanupFilterData]: (state, { payload: { filterType } }) => ({
            ...state,
            [filterType]: null
        })
    },
    initialState
);